import { CarePlanComplaint, Complaint } from '../types/PatientVisit.type';

export const orderComplaints = <T extends Complaint | CarePlanComplaint>(complaints: T[]) => {
  if (!complaints.length) return [];

  return complaints.sort((a, b) => {
    const aProblemArea = a.problemArea ?? 0;
    const bProblemArea = b.problemArea ?? 0;
    const aCreatedAt = a.added ?? a.createdAt ?? 0;
    const bCreatedAt = b.added ?? b.createdAt ?? 0;
    const createdAtTest = aCreatedAt - bCreatedAt;
    const problemAreaTest = aProblemArea - bProblemArea;

    return createdAtTest || problemAreaTest;
  });
};
